exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".squareGiftCard-submitButton {\n  margin-top: 16px; }\n\n.squareGiftCard-sq-fieldset {\n  background-color: var(--input-background-color); }\n\n.squareGiftCard-squareInputStyles {\n  background-color: transparent;\n  color: var(--input-text-color);\n  font-size: 16px;\n  line-height: 24px;\n  padding: 16px; }\n\n.squareGiftCard-formContainer {\n  margin: 20px 0; }\n", ""]);

// exports
